import React from 'react';
import { SystemCode } from '../../../../settings/settings';
import If from '../../../Shared/If/If';
import Phone from '../../../Shared/Phone/Phone';
import { checkMissingFeaturesByCode } from '../../../../utils/funds/shared/shared-fund-notes-utility';
import words from '../../../../utils/words';

const ACHRedemptionFundNoteTip = ({ fund, phoneNumber = '(800) 225-5132' }) => (
  <div className="exclude">
    <span className="exclude">
      {' '}
      Direct Deposits are unavailable using this bank.{' '}
    </span>
    <If test={checkMissingFeaturesByCode(fund, SystemCode.WIRE_REDEMPTION)}>
      Try {words.redeeming} via Check,
    </If>
    <If
      test={
        !checkMissingFeaturesByCode(fund, SystemCode.WIRE_REDEMPTION) &&
        !checkMissingFeaturesByCode(fund, SystemCode.CHECK_REDEMPTION)
      }
    >
      Try {words.redeeming} via Check or Wire,
    </If>
    <span className="exclude">
      {' '}
      or call <Phone phoneNumber={phoneNumber} /> to discuss your options with
      an associate.
    </span>
  </div>
);

export default ACHRedemptionFundNoteTip;
